import React from 'react';
import type { NextPage } from 'next';
import type WidgetModel from '@/interfaces/widget';
import { matt, kandice } from '@/content/authors';
import settings from '@/features/resources/StackedBarGraphMaker/settings';
import chartAdapter from '@/components/widget/visualizations/chartAdapters/stackedBar';
import Article from '@/features/resources/StackedBarGraphMaker/Article';
import workbookData from '@/features/resources/StackedBarGraphMaker/workbookData';
import ChartBuilder from '@/features/ChartBuilder';
import {
  widgetConfig,
  chartSectionStyles,
  sectionLgPadding,
} from '@/features/ChartBuilder/configs';
import { DEFAULT_CHART_VALUE_TEMPLATE } from '@/config/widget';

const WORKBOOK_NAME = 'Stacked Bar Graph';
const SECTION_ID = 'first';
const AUTHORS = [kandice];
const REVIEWERS = [matt];
const REVIEWS = settings.reviews || [];

const Page: NextPage = () => {
  return (
    <ChartBuilder
      widget={widget}
      workbookName={WORKBOOK_NAME}
      workbookData={workbookData}
      workbookMeta={{ sheetNames: [], formats: [] }}
      authors={AUTHORS}
      reviewers={REVIEWERS}
      settings={settings}
      reviews={REVIEWS}
      Article={Article}
    />
  );
};

export default Page;

const widget: WidgetModel = chartAdapter(SECTION_ID, {
  id: 'stacked-bar-graph-maker',
  config: widgetConfig,
  sections: {
    // @ts-ignore
    [SECTION_ID]: {
      config: {
        seriesOptions: [{}],
        layoutGroup: 'defaults',
        selections: 'B2:B|C2:C|D2:D|E2:E',
        labelsSelections: 'A2:A',
        legendsSelections: 'B1:1',
        yAxisTemplate: DEFAULT_CHART_VALUE_TEMPLATE,
        collectionOptions: [{}, {}, {}, {}],
        styles: {
          ...chartSectionStyles,
          ...sectionLgPadding,
        },
      },
    },
  },

  createdAt: 1,
  updatedAt: 1,
  publishedAt: 1,

  // @ts-ignore
  team: { id: 'none' },
  workbookFileRef: 'reporting/widget',
});
